// extracted by mini-css-extract-plugin
export default {"action":"NotFound_action__TOum6","notfound":"NotFound_notfound__ZH-n4"};